import { render } from "./empresaAfi.vue?vue&type=template&id=1b2db54f"
import script from "./empresaAfi.vue?vue&type=script&lang=js"
export * from "./empresaAfi.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__